"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OccasionMasterSchema = void 0;
exports.OccasionMasterSchema = {
    "$id": "https://www.redbull.com/schemas/master/occasions.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "OccasionMaster",
    "description": "Occasions describe the different situations in which consuming the product will give users wings.",
    "type": "object",
    "properties": {
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}$"
        },
        "type": {
            "enum": [
                "rrn:master:occasions"
            ],
            "type": "string"
        },
        "relationships": {
            "type": "object",
            "properties": {
                "translations": {
                    "type": "object",
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "properties": {
                                    "id": {
                                        "type": "string",
                                        "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
                                    },
                                    "type": {
                                        "enum": [
                                            "rrn:content:occasions"
                                        ],
                                        "type": "string"
                                    }
                                }
                            }
                        }
                    }
                },
                "translatedFrom": {
                    "type": "object",
                    "properties": {
                        "data": {
                            "type": "object",
                            "properties": {
                                "id": {
                                    "type": "string",
                                    "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
                                },
                                "type": {
                                    "enum": [
                                        "rrn:content:occasions"
                                    ],
                                    "type": "string"
                                }
                            }
                        }
                    }
                },
                "draftTranslations": {
                    "type": "object",
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "properties": {
                                    "id": {
                                        "type": "string",
                                        "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
                                    },
                                    "type": {
                                        "enum": [
                                            "rrn:content:occasions"
                                        ],
                                        "type": "string"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "additionalProperties": false
        },
        "meta": {
            "type": "object",
            "properties": {
                "published": {
                    "type": "boolean"
                },
                "status": {
                    "type": "string"
                },
                "version": {
                    "type": "number"
                },
                "dateCreated": {
                    "type": "string",
                    "pattern": "^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{3}Z$"
                },
                "dateUpdated": {
                    "type": "string",
                    "pattern": "^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{3}Z$"
                }
            }
        }
    },
    "required": [
        "id",
        "type",
        "relationships",
        "meta"
    ]
};
//# sourceMappingURL=data:application/json;base64,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